import { render, staticRenderFns } from "./HeaderPageV2.vue?vue&type=template&id=982b7edc&scoped=true"
import script from "./HeaderPageV2.vue?vue&type=script&lang=js"
export * from "./HeaderPageV2.vue?vue&type=script&lang=js"
import style0 from "./HeaderPageV2.vue?vue&type=style&index=0&id=982b7edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982b7edc",
  null
  
)

export default component.exports